export var SupportedAlgorithm;
(function (SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})(SupportedAlgorithm || (SupportedAlgorithm = {}));
;
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ethersproject/sha2/lib.esm/types.js
// module id = 54
// module chunks = 0